export const ONBOARDING_PREFERENCES_PENDING_KEY = "xphub_onboarding_preferences_pending";

export function markOnboardingPreferencesPending() {
  try {
    localStorage.setItem(ONBOARDING_PREFERENCES_PENDING_KEY, "1");
  } catch {
    // El onboarding no debe bloquear el registro si el navegador no permite localStorage.
  }
}

export function clearOnboardingPreferencesPending() {
  try {
    localStorage.removeItem(ONBOARDING_PREFERENCES_PENDING_KEY);
  } catch {
    // No bloquea navegacion.
  }
}

export function isOnboardingPreferencesPending() {
  try {
    return localStorage.getItem(ONBOARDING_PREFERENCES_PENDING_KEY) === "1";
  } catch {
    return false;
  }
}
